<template>
  <div @click="startTimer" @keyup="startTimer" @mouseup="startTimer" @mousemove="startTimer" @mousedown="startTimer">
    <el-card :style="cardHeight" >
      <div class="tab-header" style="padding-bottom: 40px; border-bottom: 1px solid #EBEEF5;">
        <span style="float: left;color:#5ddddc;margin-right: 5px">|</span>
        <span style="font-weight: bolder;float: left;font-size: 15px">论文信息</span>
        <el-button type="primary" size="small" style=" float: right; margin-bottom: 10px" @click="handleAddClick"
                   v-if="this.$route.query.flag == 'add' || this.$route.query.flag == 'update' ">
          新增论文
        </el-button>
      </div>
      <div class="tab-body" :style="tabHeight" style="margin-top: 20px; padding-bottom: 20px" >
        <el-scrollbar style="height: 100%;" ref="scrollbar">
          <el-table v-loading="data.isLoading" :data="data.list" border size="small">
            <el-table-column align="center" prop="paperId" label="论文id" fixed :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="paperTitle" label="论文题目" fixed :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="paperTypeCode" label="论文类别代码" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="postJournal" label="发布期刊" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="postDate" label="发表日期">
              <template slot-scope="scope">{{ scope.row.postDate | MonthFormat }}</template>
            </el-table-column>
            <el-table-column align="center" prop="postPage" label="年卷期页" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="firstAuthorName" label="第一作者" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="firstAuthorSection" label="第一作者科室" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="statSrcJournalInclu" label="统计源期刊收录"></el-table-column>
            <el-table-column align="center" prop="cnCoreJournalInclu" label="中文核心期刊收录"></el-table-column>
          <el-table-column  align="center" prop="normalCnJournalInclu" label="一般中文期刊收录" ></el-table-column>
          <el-table-column  align="center" prop="cnSeriesJournal" label="中华系列期刊" ></el-table-column>
          <el-table-column  align="center" prop="sci" label="期刊" ></el-table-column>
          <el-table-column  align="center" prop="ei" label="ei" ></el-table-column>
          <el-table-column  align="center" prop="normalFrJournalInclu" label="一般外文期刊收录" ></el-table-column>
          <el-table-column  align="center" prop="cnSeriesJournal" label="中华系列期刊" ></el-table-column>
          <el-table-column  align="center" prop="ssci" label="ssci" ></el-table-column>
          <el-table-column  align="center" prop="istp" label="刊物" ></el-table-column>
          <el-table-column  align="center" prop="ca" label="ca" ></el-table-column>
          <el-table-column  align="center" prop="ba" label="ba" ></el-table-column>
          <el-table-column  align="center" prop="em" label="em" ></el-table-column>
          <el-table-column  align="center" prop="im" label="im" ></el-table-column>
          <el-table-column  align="center" prop="impactFactor" label="影响因子"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column  align="center" prop="corrAuth" label="通讯作者" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column  align="center" prop="authList" label="作者列表"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column  align="center" prop="rnk" label="排名" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column  align="center" prop="statusCode" label="状态代码"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column  align="center" prop="reimOrAwards" label="报销或奖励" :show-overflow-tooltip="true" ></el-table-column>
          <el-table-column  align="center" prop="reimProgress" label="报销进度"  :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="summary" label="摘要" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="corrAuthSection" label="通讯作者科室" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="操作" align="center" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button style="border:0px !important;" type="text" size="small" @click="handleViewClick(scope.row)">查 看
                </el-button>
                <el-button v-if="$route.query.flag == 'add' || $route.query.flag == 'update'" style="border:0px !important;" type="text" size="small"
                           @click="handleUpdateClick(scope.row,scope.$index)">修 改
                </el-button>
                <el-button v-if="$route.query.flag == 'add' || $route.query.flag == 'update'" style="border:0px !important;" type="text" size="small"
                           @click="handleDeleteClick(scope.row)">删 除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="float: right"
            background
            layout="prev, pager, next"
            :total="pagination.pageCount"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            @current-change="clickChangePage">
          </el-pagination>
        </el-scrollbar>
      </div>

      <el-dialog width="90%" :close-on-click-modal="false" :visible.sync="dialog.isShow" class="spec-dialog" @close="handleCloseDialog" style="bottom: -30px;">
        <div class="dialog-title" slot="title">
          <template v-if="Object.is(dialog.dialogType,dialogType.add)">新增论文信息</template>
          <template v-if="Object.is(dialog.dialogType,dialogType.view)">查看论文信息</template>
          <template v-if="Object.is(dialog.dialogType,dialogType.update)">编辑论文信息</template>
        </div>
       <div class="panelLeft"  style="overflow-y: hidden;">
         <div style="height: 10px;text-align: center;padding-bottom:40px;font-size: 16px;font-weight: bold">论文信息</div>
         <el-scrollbar style="height: calc(100% - 30px);" ref="scrollbar">
           <el-form style="width: calc(100% - 10px)" label-width="130px" v-loading="dialog.isLoading" :rules="rules" ref="ruleForm" :model="dialog.form">
           <el-form-item label="论文id" prop="paperId">
             <el-input v-model="dialog.form.paperId" type="text"  placeholder="请输入论文id" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="论文题目" prop="paperTitle">
             <el-input v-model="dialog.form.paperTitle" type="text" placeholder="请输入论文题目" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="论文类别代码" prop="paperTypeCode">
             <el-input v-model="dialog.form.paperTypeCode" type="text"  placeholder="请输入论文类别代码" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="发布期刊" prop="postJournal">
             <el-input v-model="dialog.form.postJournal" type="text" placeholder="请输入发布期刊" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="发表日期">
             <el-date-picker type="month" v-model="dialog.form.postDate" style="width: 100%;" placeholder="选择日期"
                             :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-date-picker>
           </el-form-item>
           <el-form-item label="年卷期页" prop="postPage">
             <el-input v-model="dialog.form.postPage" type="text" placeholder="请输入年卷期页" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="第一作者" prop="firstAuthorName">
             <el-input v-model="dialog.form.firstAuthorName" type="text" placeholder="请输入第一作者" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="第一作者科室" prop="firstAuthorSection">
             <el-input v-model="dialog.form.firstAuthorSection" type="text" placeholder="请输入第一作者科室" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="统计源期刊收录" prop="statSrcJournalInclu">
             <el-input v-model="dialog.form.statSrcJournalInclu" type="text" placeholder="请输入统计源期刊收录" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="中文核心期刊收录" prop="cnCoreJournalInclu">
             <el-input v-model="dialog.form.cnCoreJournalInclu" type="text" placeholder="请输入中文核心期刊收录" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="一般中文期刊收录" prop="normalCnJournalInclu">
             <el-input v-model="dialog.form.normalCnJournalInclu" type="text" placeholder="请输入一般中文期刊收录" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="期刊" prop="sci">
             <el-input v-model="dialog.form.sci" type="text" placeholder="请输入sci" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="ei" prop="ei">
             <el-input v-model="dialog.form.ei" type="text" placeholder="请输入ei" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="一般外文期刊收录" prop="normalFrJournalInclu">
             <el-input v-model="dialog.form.normalFrJournalInclu" type="text" placeholder="请输入一般外文期刊收录" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="中华系列期刊" prop="cnSeriesJournal">
             <el-input v-model="dialog.form.cnSeriesJournal" type="text" placeholder="请输入中华系列期刊" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="ssci" prop="ssci">
             <el-input v-model="dialog.form.ssci" type="text" placeholder="请输入ssci" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="刊物" prop="istp">
             <el-input v-model="dialog.form.istp" type="text" placeholder="请输入刊物" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="ca" prop="ca">
             <el-input v-model="dialog.form.ca" type="text" placeholder="请输入ca" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="ba" prop="ba">
             <el-input v-model="dialog.form.ba" type="text" placeholder="请输入ba" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="em" prop="em">
             <el-input v-model="dialog.form.em" type="text" placeholder="请输入em" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="im" prop="im">
             <el-input v-model="dialog.form.im" type="text" placeholder="请输入im" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="影响因子" prop="impactFactor">
             <el-input v-model="dialog.form.impactFactor" type="text" placeholder="请输入影响因子" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="通讯作者" prop="corrAuth">
             <el-input v-model="dialog.form.corrAuth" type="text" placeholder="请输入通讯作者" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="作者列表" prop="authList">
             <el-input v-model="dialog.form.authList" type="text" placeholder="请输入作者列表" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="排名" prop="rnk">
             <el-input v-model="dialog.form.rnk" type="text" placeholder="请输入排名" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="状态代码" prop="statusCode">
             <el-input v-model="dialog.form.statusCode" type="text" placeholder="请输入状态代码" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="报销或奖励" prop="reimOrAwards">
             <el-input v-model="dialog.form.reimOrAwards" type="text" placeholder="请输入报销或奖励" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="报销进度" prop="reimProgress">
             <el-input v-model="dialog.form.reimProgress" type="text" placeholder="请输入报销进度" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="摘要" prop="summary">
             <el-input v-model="dialog.form.summary" type="text" placeholder="请输入摘要" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)">
             </el-input>
           </el-form-item>
           <el-form-item label="通讯作者科室" prop="corrAuthSection">
             <el-input v-model="dialog.form.corrAuthSection" type="text" placeholder="请输入通讯作者科室" clearable
                       :disabled="Object.is(dialogType.view, dialog.dialogType)"></el-input>
           </el-form-item>
         </el-form>
         </el-scrollbar>
       </div>
      <div class="panelRight" style="height: 80%;overflow-y: hidden;text-align: center">
        <div style="text-align: center;padding-bottom:20px;font-size: 16px;font-weight: bold">附件列表</div>
        <el-upload
          v-if="dialog.opt"
          style="height: 40%"
          class="upload-demo"
          drag
          action
          multiple
          :show-file-list="false"
          fullscreen="true"
          :before-remove="beforeRemove"
          :http-request="fileUpload"
          :accept="acceptAttachmentType"
          :before-upload='handleBeforeUpload'>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em></div>
          <!--        <div class="el-upload__tip" slot="tip">仅支持xls/xlsx文件</div>-->
        </el-upload>
        <el-scrollbar :style="dialog.opt ? 'height: calc(60% - 50px)':'height: calc(100% - 50px)'" ref="scrollbar">
        <div style="width: calc(100% - 10px)">
          <el-table :data="fileDialog.tableDataList" border size="small">
            <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称" ></el-table-column>
            <el-table-column align="center" prop="attachmentName" label="文件别名" >
              <template slot-scope="scope">
                <el-input :placeholder="Object.is(dialogType.view, dialog.dialogType) ? '' :'输入别名'" class="text-input" :disabled="Object.is(dialogType.view, dialog.dialogType)" v-model="scope.row.attachmentName"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="操作" width="100">
              <template slot-scope="scope">
                <!--查看附件-->
                <el-button style="border:0px !important;" type="text" size="small" class="el-icon-view" @click="preViewAttachment(scope.row,scope.$index)"></el-button>
                <!--移除附件-->
                <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close" @click="beforeRemove(scope.row,scope.$index)" v-if="dialog.editedFlag"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        </el-scrollbar>

      </div>

        <template slot="footer">
          <el-button @click="handlePasteReferenceDialog"  size="small" type="primary" v-show="this.$route.query.flag != 'view' && dialog.editedFlag">粘贴引用</el-button>
          <el-button @click="handleCommitDialog" size="small" type="primary" v-show="this.$route.query.flag != 'view' && dialog.editedFlag">保存</el-button>
          <el-button @click="handleCloseDialog" size="small" type="info">取消</el-button>
        </template>
      </el-dialog>

      <el-dialog :visible.sync="pasteDialog.isShow" @close="handleClosePasteDialog" width="600px">
        <div class="dialog-title" slot="title">
          <template>粘贴引用</template>
        </div>
        <el-form label-width="100px" v-loading="dialog.isLoading">
          <el-input v-model="pasteDialog.pasteText" :maxlength="400" type="textarea" :rows="10" placeholder="请输入粘贴引用内容" clearable></el-input>
        </el-form>
        <template slot="footer" >
          <el-button @click="handleDetermineDialog" size="small" type="primary" v-show="this.$route.query.flag != 'view'">确定</el-button>
          <el-button @click="handleClosePasteDialog" size="small" type="info">关闭</el-button>
        </template>
      </el-dialog>



      <div class="demo-image__preview">
        <el-image
          ref="previewImg"
          :preview-src-list="attachment.attachmentsLink">
        </el-image>
      </div>
    </el-card>


    <animation :loadingDataVisible="!attachmentUploadState || !formInfoSaveState" :loadingText="loadingText"></animation>


  </div>
</template>

<script>
  import * as constantsRules from '@/constants/constantRules'
  import {ATTA_FILE_SUF_LIST,ATTA_FILE_SHOW_TYPE,ATTA_FILE_DOWN_TYPE,ATTA_UPLOAD_COMPONENT_TYPE_STR,SINGLE_ATTACHMENT_MAX_SIZE} from '@/constants/constants'
  import {mapState} from "vuex";
  import {Message} from "element-ui";
  import cookie from "@/utils/cookie";
  import http from "@/utils/axios";
  import {DIALOG_TYPE_ADD,DIALOG_TYPE_VIEW,DIALOG_TYPE_UPDATE,CARD_HEIGHT_TYPE,TAB_HEIGHT_TYPE,PAGE_SIZE_TYPE} from '@/constants/constants'
  import animation from '@/components/loading/animation'

  export default {
    name: "BasicInfo",
    components:{animation},
    data() {
      return {
        //true是结束,false是正在处理
        attachmentUploadState:true,
        //true是结束,false是正在处理
        formInfoSaveState:true,
        //附件的允许上传的类型
        acceptAttachmentType: ATTA_UPLOAD_COMPONENT_TYPE_STR,
        //单个附件的最大的大小
        singleAttachmentSize: SINGLE_ATTACHMENT_MAX_SIZE,

        loadingText:null,
        attachment:{
          attachmentsLink:[],
          //图片的类型后缀
          imagesType:['jpg','jpeg','png','gif'],
        },
        pagination: {
          //数据页总数
          pageCount: 1,
          //当前页
          currentPage: 1,
          //页数据大小
          pageSize: PAGE_SIZE_TYPE,
        },
        data: {
          isLoading: false,
          list: [],
          allData:[]
        },
        dialogType: {
          add: DIALOG_TYPE_ADD,
          view: DIALOG_TYPE_VIEW,
          update: DIALOG_TYPE_UPDATE
        },
        fileDialog:{
          attachmentName:'',
          cd:'001-002',
          //真实的附件信息,没有id的,只是附件的二进制文件 的数组
          fileList: [],
          //附件的名字而已,别名 code id...  的数组
          tableDataList:[],
          attaFileSuf:ATTA_FILE_SUF_LIST,
          attaFileType:ATTA_FILE_SHOW_TYPE,
          attaFileDownType:ATTA_FILE_DOWN_TYPE,
          drawerVisible: false,
          fileSaveBtnLoading: false,
          updateFlag:false,
          uploadLoading:false,
        },
        dialog: {
          dialogType: null,
          isShow: false,
          isLoading: false,
          editedFlag: false,
          //附件上传框 是否可见
          opt:false,
          form:{
            id: '',
            paperId:'',
            paperTitle:'',
            paperTypeCode:'',
            postJournal:'',
            postDate:'',
            postPage:'',
            firstAuthorName:'',
            firstAuthorSection:'',
            statSrcJournalInclu:'',
            cnCoreJournalInclu:'',
            normalCnJournalInclu:'',
            cnSeriesJournal:'',
            ssci:'',
            sci:'',
            ei:'',
            normalFrJournalInclu:'',
            istp:'',
            ca:'',
            ba:'',
            em:'',
            im:'',
            impactFactor:'',
            corrAuth:'',
            authList:'',
            rnk:'',
            statusCode:'',
            reimOrAwards:'',
            reimProgress:'',
            summary:'',
            corrAuthSection:'',
            userId: '',
            //附加列表
            attachIds: [],
          }
        },
        pasteDialog:{
          dialogType: null,
          isShow: false,
          isLoading: false,
          pasteText: '',
        },
        cardHeight:{
          height:''
        },
        tabHeight: {
          height: ''
        },
        timeOut: '',   //定时器
        updateIndex: '',     //修改的索引
        updateCurrIndex: '',     //修改当前的索引
        rules: constantsRules.PaperInfoRules,
        editSelf:'0'
      }

    },
    watch:{
      "data.allData.length": {
        handler(newVal, oldVal) {
          this.pagination.pageCount = this.data.allData.length
          //新增
          if (newVal > oldVal) {
            if (oldVal !== 0) {
              this.clickChangePage((Math.ceil(this.data.allData.length / this.pagination.pageSize)))
            }
            //删除
          } else if (newVal < oldVal) {
            this.clickChangePage((this.pagination.currentPage === 1 || this.data.list.length !== 0) ? this.pagination.currentPage : this.pagination.currentPage - 1)
          }
        },
        deep:true
      },
    },
    mounted() {
      //进入页面显示数据到表单中
      // this.data.list = this.eimsUserInfPapers;
      //所有数据,非仅当前页面的数据
      this.data.allData = this.eimsUserInfPapers;
      this.pagination.pageCount = this.eimsUserInfPapers.length
      this.changeShowData()

      //若是新增或者修改页面，就启用定时器
      if (this.$route.query.flag == "add" || this.$route.query.flag == 'update') {
        this.startTimer();
      }
    },

    //清除定时器
    beforeDestroy() {
      let that = this;
      that.$once('hook:beforeDestroy',() =>{
        clearInterval(that.timeOut)
      })
    },

    methods: {
      //设置自适应高度
      getHeight() {
        this.cardHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE) + 'px';
        this.tabHeight.height = (window.innerHeight- CARD_HEIGHT_TYPE - TAB_HEIGHT_TYPE) + 'px';
      },

      //页面单击修改页面的时候触发修改页码
      clickChangePage(page) {
        this.pagination.currentPage = page
        this.changeShowData()
      },

      //修改页面显示的数据
      changeShowData() {
        this.data.list = []
        let start = (this.pagination.currentPage - 1) * this.pagination.pageSize
        let end = this.pagination.currentPage * this.pagination.pageSize > this.data.allData.length ? this.data.allData.length : this.pagination.currentPage * this.pagination.pageSize
        for (let i = start; i < end; i++) {
          this.data.list.push(this.data.allData[i])
        }
      },

      //页面5分钟无操作时自动调用接口
      startTimer() {
        let that = this;
        clearInterval(that.timeOut);
        that.timeOut = setInterval(()=>{
          that.handleCommitClick("auto");
        },5*60*1000)
      },

      //点击添加出现弹窗
      handleAddClick() {
        //设置上传文件的框可见
        this.dialog.opt=true;
        this.fileDialog.tableDataList = [];
        this.fileDialog.fileList=[];
        // Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
        this.dialog.isShow = true;
        // this.dialog.form = {};
        this.dialog.dialogType = DIALOG_TYPE_ADD;
        this.dialog.editedFlag = true;
        this.dialog.form.attachIds = [];
      },

      //点击查看表单信息
      handleViewClick(row) {
        //设置上传文件的框不可见
        this.dialog.opt=false
        this.fileDialog.tableDataList = row.attachIds
        this.dialog.editedFlag = false;
        let that = this;
        that.dialog.dialogType = DIALOG_TYPE_VIEW;
        let list = that.eimsUserInfPapers;
        list.forEach((arr) => {
          if (list.indexOf(arr) == list.indexOf(row)){
            that.dialog.form = JSON.parse(JSON.stringify(arr));
          }
        })
        this.openFileList()
        that.dialog.isShow = true;
      },

      //点击修改表单信息
      handleUpdateClick(row,index) {
        this.fileDialog.tableDataList = row.attachIds
        //设置上传文件的框可见
        this.dialog.opt=true
        this.dialog.editedFlag = true;
        let that = this;
        that.dialog.isShow = true;
        that.dialog.dialogType = DIALOG_TYPE_UPDATE;
        let list = that.eimsUserInfPapers;
        list.forEach((arr) => {
          if (list.indexOf(arr) == list.indexOf(row)) {
            let arr1 = JSON.parse(JSON.stringify(arr));
            that.dialog.form = arr1;
            that.updateIndex = list.indexOf(row);
          }
        })
        that.updateCurrIndex = index
        this.openFileList()
      },


      //点击删除表单信息
      handleDeleteClick(row) {
        this.$confirm(`确定将 ${row.paperId}:《${row.paperTitle}》 删除？`,{
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() =>{
          this.deletePaperById(row)
        }).catch(()=>{})
      },

      deletePaperById(row){
        let obj={
          token:cookie.getCookie("token"),
          data:{
            id:row.id,
            userId:row.userId,
          }
        }
        //移除成功和失败不需要提示
        http.post(window.config.api.baseUrl + '/eims-api/paper/delete', obj).then(response => {
          if(response.data.code === '00000'){
            Message.success("论文删除成功")
            this.updateDataCache(row)
          }
        }).finally(() => {

        })
      },

      updateDataCache(row){
        let that = this;
        let list = that.data.list;
        list.forEach((arr) => {
          if (list.indexOf(arr) == list.indexOf(row)) {
            that.data.list.splice(list.indexOf(arr),1)
            //删除总数据中的某一项
            that.$store.state.paperInfoModule.eimsUserInfPapers.splice(that.data.allData.indexOf(row),1)
          }
        })

      },

      //提交弹窗信息
      handleCommitDialog(row){
        //校验数据
        if(!this.validateDialogForm()){
          return false
        }

        this.loadingText="保存中"
        this.setLoadingVisibleState(true)
        //如果有附件就提交附件
        if(this.fileDialog.fileList.length !== 0){
          this.loadingText="上传中"
          //先上传附件的信息,后面还有一个 缓存数据方法
          this.saveDeptByFile()
        }else{

          //没有新的附件上传
          let updateAttachments=[]
          let start=this.fileDialog.tableDataList.length - this.fileDialog.fileList.length
          for (let i= 0 ;i<start ;i++){
            updateAttachments.push({
              id: this.fileDialog.tableDataList[i].id,
              attachmentName : this.fileDialog.tableDataList[i].attachmentName,
              attachmentOriginalName: this.fileDialog.tableDataList[i].attachmentOriginalName,
            })
          }

          this.attachmentUploadState = true
          //保存论文的信息,包括修改附件的别名
          this.savePaperInfo();
        }
      },

      //相关操作
      pushDataToCache(form){
        if (this.dialogType.add == this.dialog.dialogType){
          this.data.list.push(form);
          this.data.allData.push(form);
        }else if(this.dialogType.update == this.dialog.dialogType){
          //设置附件的列表数据
          this.fileDialog.tableDataList =  this.dialog.form.attachIds
          this.data.allData.splice(this.updateIndex,1,form)
          this.data.list.splice(this.updateCurrIndex,1,form);
        }
      },

      //提交操作的数据
      handleCommitClick(param){
        let that = this;
        //将页面信息存到modules中
        that.$store.dispatch("getPaperInfo", {"eimsUserInfPapers": that.data.allData,"userId": that.userId});
        //提交数据
        let flag = 'UPDATE';
        let editSelf = this.editSelf;
        //如果userModule中的userId有值，则创建用户变成修改用户
        // if(that.userUserId){
        //   flag = "UPDATE"
        // }
        //userModule中的userId没有值或者userModule中userId值等于输入框中的userId值，方可调用接口
        if (!that.userUserId || that.userUserId == that.userId){
          that.$store.dispatch("updateOrInsertMemberInfo",flag,param).then(value => {
            if(value.data.code == '00000'){
              if (this.$route.query.flag == "add"){
                Message.success({message:"创建用户成功", showClose: true});
              }else if(this.$route.query.flag == "update"){
                Message.success({message:"修改用户成功", showClose: true});
              }
              if (param != "auto"){
                this.$router.push({path:'/user/list'});
              }
              this.$store.dispatch("getEimsUser",{"userId": this.userId})
            }
          })
        }

      },

      handleCloseDialog(){
        this.dialog.isShow = false;
        //以下代码会导致查看的数据丢失
        // this.dialog.form = {};
        // this.$refs['ruleForm'].resetFields();
        this.$refs['ruleForm'].resetFields();
        Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
        this.fileDialog.fileList = [];
        this.dialog.editedFlag = false;
        // this.dialog.form.attachIds = this.fileDialog.tableDataList
      },
      handleCloseFileDialog(){
        let _this =this;
        _this.fileDialog.fileList = [];
        _this.fileDialog.tableDataList = [];
        _this.fileDialog.drawerVisible = false;
        _this.fileDialog.updateFlag = false;
      },
      handleCancelFileDialogClick(){
          this.handleCloseFileDialog();
      },
      handleCancelClick(){
        if (this.$route.query.path == '/user/approve') {
          this.$router.push({path:'/user/approve'});
        }else {
          this.$router.push({path:'/user/list'});
        }
      },
      //跳转到上一个页面
      goPrePageClick(){
        let data='/user/info/basic';   //要传的值
        //子路由通过$emit触发父级路由中的方法
        this.$emit('childClick',data);
      },
      //跳转到下一个页面
      goNextPageClick(){
        let data = '/user/info/work';
        this.$emit('childClick', data);
      },

      validateFileForm(){
        return true;
      },

      //弹窗信息校验
      validateDialogForm() {
        let result = false;
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            result = true;
          }
        });
        return result;
      },

      //fileDialog方法
      fileUpload(file, fileList) {
        if (file.file.size > this.singleAttachmentSize){
          Message.error("上传的附件大小不能大于10MB")
          return
        }
        //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
        //所以需要定义两个,一个用于显示文件名,一个用于接受文件
        this.fileDialog.fileList.push(file);
        //设置文件的原名
        this.fileDialog.tableDataList.push({
          attachmentOriginalName:file.file.name
        })

      },

      // 上传之前判断类型
      handleBeforeUpload(file) {
        let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (!this.fileDialog.attaFileSuf.includes(testMsg)) {
          this.$message({
            message: '上传附件类型不合法！',
            type: 'warning',
            showClose:true
          })
          return false
        } else {
          return true
        }
      },

      //在新增附加的时候移除
      handleRemoveOnAdd(item,idx) {
        let removeName = item.fileName;
        let numberFile = this.fileDialog.fileList.findIndex((f) => f.file.name == removeName);
        this.fileDialog.fileList.splice(numberFile,1)
      },

      //在检查的时候移除
      handleRemoveOnCheck(item,idx) {
        let removeName = item.fileName;
        let number = this.fileDialog.fileList.findIndex((f) => f.file.name == removeName);
        this.tableDataList.splice(idx,1)
        this.fileDialog.fileList.splice(number,1)
      },

      //点击移除按钮的时候提执行
      beforeRemove(item,idx) {
        let oldData = []
        for (let item of this.fileDialog.tableDataList){
          if(item.id){
            oldData.push(item)
          }
        }

        let index = this.fileDialog.tableDataList.length - oldData.length
        this.fileDialog.tableDataList.splice(idx,1);
        if (index === 0){
          //代表没有新加的文件
          this.fileDialog.fileList.splice(idx,1)
        }else {
          //old 4  new 2  count 6 remove 最后一个(count(index) = 5 , removeIndex(index) = 1)
          //old 4  new 3  count 7 remove 倒数第二个(count(index) = 5 , removeIndex(index) = 1)
          //old 4  new 4  count 8 remove 倒数第三个(count(index) = 5 , removeIndex(index) = 1)
          // let removeIndex = count - old - (count - idx )
          //7-4-(7-5)
          // let removeIndex = this.fileDialog.tableDataList.length - oldData.length - ( this.fileDialog.tableDataList.length - idx)
          //化简
          let removeIndex = idx - oldData.length
          //负数的索引会重最后一个对象开始删起
          if(removeIndex >= 0){
            this.fileDialog.fileList.splice(removeIndex,1)
          }
        }
      },

      //删除附件
      deleteAttachmentById(id){
        let obj={
          token:cookie.getCookie("token"),
          data:{
            attachmentId:id,
          }
        }
        //移除成功和失败不需要提示
        http.post(window.config.api.baseUrl + '/eims-api/userInfo/attachment/delete', obj).then(response => {
            if(response.data.code === '00000'){
              //这里是未了删除附件的缓存数据的
                this.pushDataToCache(this.dialog.form);
            }
        }).finally(() => {

        })
      },

      saveTemp(){
        this.dialog.form.attachIds = JSON.parse(JSON.stringify(this.fileDialog.tableDataList));
        this.fileDialog.drawerVisible = false;
      },

      saveDeptByFile() {
        if (this.fileDialog.fileList.length === 0) {
          Message.error({message: "请先选择上传的文件", showClose: true});
          return
        }
        let attachment = [];
        let start=this.fileDialog.tableDataList.length - this.fileDialog.fileList.length
        let end = this.fileDialog.tableDataList.length
        //只需要上传新的数据即可
        for (let i= start ;i<end ;i++){
          attachment.push({
            attachmentName : this.fileDialog.tableDataList[i].attachmentName,
            attachmentOriginalName : this.fileDialog.tableDataList[i].attachmentOriginalName,
          })
        }

        //上传附件
        this.uploadFiles(attachment,this.fileDialog.tableDataList)

      },

      //上传附件
      uploadFiles(attachment,updateAttachments){
        let _this=this
        // 使用form表单的数据格式
        const paramsData = new FormData()
        // 将上传文件数组依次添加到参数paramsData中
        this.fileDialog.fileList.forEach((it, index) => {
          paramsData.append(`file`, it.file);
        });
        let jsonData = {
          token: cookie.getCookie("token"),
          data:{
            cd:_this.fileDialog.cd,
            attachment: attachment
          }
        }
        Message.info("附件上传可能需要几分钟,请耐心等待");
        //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
        paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
        // 表单数据和文件一起上传,调用后端接口
        this.fileDialog.uploadLoading = true
        http.post(window.config.api.baseUrl + '/eims-api/userInfo/attachment/add', paramsData).then(response => {
          if (response.data.code === '00000') {
            let attachment = response.data.data.attachment;
            if (!this.dialog.form.attachIds) {
              this.dialog.form.attachIds = [];
            }
            for (let i in attachment){
              let temp = {};
              temp.id = attachment[i].id;
              temp.code = attachment[i].code
              temp.attachmentName = attachment[i].attachmentName;
              temp.attachmentOriginalName = attachment[i].attachmentOriginalName;
              this.fileDialog.tableDataList.push(temp)
              //清空原文件的数组
              this.fileDialog.fileList = []
            }
            //保存论文的信息,包括修改附件的别名
            this.savePaperInfo();
          }else {
            //如果后端抛出了异常 ,需要关闭加载动画
            this.setLoadingVisibleState(false)
          }
        }).finally(() => {
          this.attachmentUploadState = true
          this.dialog.isShow = false
          this.fileDialog.drawerVisible = false;
          this.fileDialog.uploadLoading = false;
        })
      },

      //最后保存论文的信息
      savePaperInfo(){
        let attachments = this.fileDialog.tableDataList
        let updateAttachments = []
        //筛选出id不为null的文件的数据
        for (let attachment of attachments){
            if (attachment.id !=null){
              updateAttachments.push(attachment)
            }
        }
        this.dialog.form.attachIds= updateAttachments
        this.dialog.form.userId=this.userId

        let obj={
          token:cookie.getCookie("token"),
          data:{
            "eimsUserInfPapers":this.dialog.form,
            "userId": this.userUserId
          }
        }
        http.post(window.config.api.baseUrl + '/eims-api/paper/update', obj).then(response => {
          if (response.data.code === '00000'){
            if(Object.is(this.dialogType.update, this.dialog.dialogType)){
              Message.success("论文修改成功")
            }else if(Object.is(this.dialogType.add, this.dialog.dialogType)){
              Message.success("论文新增成功")
            }
            //将数据添加到缓存中
            this.pushDataToCache(response.data.data.userInfPaper)
          }
        }).finally(() => {
          this.dialog.isShow = false;
          this.formInfoSaveState = true
        })


      },


      //进入附件上传框
      batchImport(file) {
        this.fileDialog.fileList = [];
        this.fileDialog.drawerVisible = true;
        this.fileDialog.updateFlag = true;

      },

      //点击查看按钮
      preViewAttachment(item,index){
        //准备需要查看的附件的链接,然后显示或者下载附件
        let fullName=  item.attachmentOriginalName

        //如果不是图片的格式的附件,则使用上面这种预览方式
        if(!this.attachment.imagesType.includes(fullName.substring(fullName.lastIndexOf(".") + 1))){
          //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
          let file = this.fileDialog.fileList[index-(this.fileDialog.tableDataList.length-this.fileDialog.fileList.length)]
          if (file){
            //附件未上传预览
            this.handleView(file)
          }else{
            //附件已上传的预览
            this.handleView(this.fileDialog.tableDataList[index])
          }

          //如果是图片则使用这种预览方式
        }else{
          //生成附件的预览链接
          this.generateAttachmentsPath(this.fileDialog.tableDataList,index)
          if (  this.attachment.attachmentsLink.length !==0 ){
            //el-image组件的预览
            this.$refs.previewImg.showViewer = true;
          }else{
            //浏览器自带的预览,附件列表的数据长度可能和表格中显示的长度不一致,需要重新修改显示的附件的索引
            this.handleView(this.fileDialog.fileList[index-(this.fileDialog.tableDataList.length-this.fileDialog.fileList.length)])
          }
        }
      },

      //打开附件,准备附件的数据
      openFileList(){
        if (this.dialog.form.attachIds && this.dialog.form.attachIds.length>0){
          this.fileDialog.tableDataList = JSON.parse(JSON.stringify(this.dialog.form.attachIds))
        }
        this.fileDialog.drawerVisible = true;
        this.fileDialog.updateFlag = false;
      },


      //将传来的附件生成附件的链接
      generateAttachmentsPath(attachments,index){
        let attachmentsLink=[]
        //将index这个文件放在第一个,给image组件使用的
        for (let i=index; i<attachments.length;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if (attachment.code !== undefined){
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+attachment.code);
            }
          }
        }
        if ( attachmentsLink.length === 0 ){
          this.attachment.attachmentsLink = []
          return
        }
        for (let i=0; i<index;i++){
          let attachment=attachments[i]
          let attachName= attachment.attachmentOriginalName
          if (this.attachment.imagesType.includes(attachName.substring(attachName.lastIndexOf(".") + 1))){
            if(attachment.code !== undefined) {
              attachmentsLink.push(window.config.api.baseUrl + '/eims-api/attachment/findFile?token=' + cookie.getCookie("token") + '&code=' + attachment.code);
            }
          }
        }
        this.attachment.attachmentsLink=attachmentsLink
      },

      //准备需要查看的附件的链接,然后显示或者下载附件
      handleView(item){
        if (item.file){
          let fileType= item.file.name.substring(item.file.name.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            elink.download = item.file.name;
          }
          elink.style.display = 'none';
          elink.target='_blank';
          // elink.href = URL.createObjectURL(new Blob([item.file.raw],{type:attaFileTypeElement}));
          elink.href = URL.createObjectURL(item.file);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          let fileType= item.attachmentOriginalName.substring(item.attachmentOriginalName.lastIndexOf('.') + 1)
          let attaFileTypeElement = this.fileDialog.attaFileType[fileType];
          const elink = document.createElement('a');
          if (!attaFileTypeElement){
            http.get(window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code,
              { responseType: "blob" }).then(response => {
              if (response){
                let attaFileDownTypeElement = this.fileDialog.attaFileDownType[fileType];
                elink.download = item.attachmentName;
                elink.style.display = 'none';
                elink.target='_blank';
                elink.href = URL.createObjectURL(new Blob([response.data],{type:attaFileDownTypeElement}));
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }).catch(error =>{
              console.log(error)
            })
          }else {
            elink.style.display = 'none';
            elink.target='_blank'
            elink.href = window.config.api.baseUrl + '/eims-api/attachment/findFile?token='+cookie.getCookie("token")+'&code='+item.code;
            // elink.href = URL.createObjectURL(new Blob([response],{type:attaFileTypeElement}));
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        }
      },

      //预留的方法 ,可以先不用复制
      updateAllData(){
        let obj={
          token: cookie.getCookie("token"),
          data:{
            userId:this.userId
          }
        }

        http.post(window.config.api.baseUrl + '/eims-api/paper/paperInfo', obj).then(response => {
          if (response.data.code === '00000'){
            let eimsUserInfPapers= response.data.data.eimsUserInfPapers
           this.$store.dispatch("getPaperInfo", {"eimsUserInfPapers": eimsUserInfPapers});
          }
        }).catch(error =>{
          console.log(error)
        })

      },

      //设置动画加载是否显示
      setLoadingVisibleState(flag){
        this.formInfoSaveState = !flag
        this.attachmentUploadState= !flag
      },

      //外层提交，基本信息页需要先保存，所以需要通信，但本质子路由页面都需要此方法
      commitEimsUserBasic(){

      },

      //粘贴引用代码
      handlePasteReferenceDialog() {
        this.pasteDialog.isShow = true;

      },

      //关闭粘贴引用框
      handleClosePasteDialog() {
        this.pasteDialog.isShow = false;
        this.pasteDialog.pasteText = '';
      },

      //粘贴引用框确定按钮
      handleDetermineDialog(){
        let str = this.pasteDialog.pasteText;
        // let str = "[1]李世勇,陈香岩,吴光亮,乔利军,胡明哲.幽门螺杆菌感染与缺血性脑卒中发病风险相关性的Meta分析[J].现代预防医学,2022,49(04):752-758."
        let patt =/\[[0-9]\](.*)\.(.*)\[.*\]\.(.*),(.*),(.*):/
        let array = str.split(patt)
        // this.$set(this.dialog.form, 'firstAuthorName',JSON.parse(JSON.stringify(array[1].split(",")[0])));
        // this.$set(this.dialog.form, 'paperTitle',JSON.parse(JSON.stringify(array[2])));
        // this.$set(this.dialog.form, 'postDate',new Date(array[4]+"-01"));
        // this.$set(this.dialog.form, 'postJournal',array[3]);
        // this.$set(this.dialog.form, 'authList', array[1])
        this.dialog.form.firstAuthorName =JSON.parse(JSON.stringify(array[1].split(",")[0])) ;
        this.dialog.form.paperTitle = JSON.parse(JSON.stringify(array[2]));
        this.dialog.form.postJournal = array[3]
        this.dialog.form.postDate = new Date(array[4]+"-01");
        this.dialog.form.authList = array[1];
        this.pasteDialog.isShow = false;
      }

    },

    created() {
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
      this.editSelf = this.$route.query.isSelf;
    },

    destroyed() {
      this.$store.dispatch("getPaperInfo", {"eimsUserInfPapers": this.data.allData,"userId": this.userId});

      window.removeEventListener('resize', this.getHeight);
    },

    computed: {
      ...mapState({
        //仅需要当前页面需要的数据,无需设置其他的页面的module数据
        eimsUserInfPapers: state => state.paperInfoModule.eimsUserInfPapers || [],
        userId: state => state.basicInfoModule.userId,
        userUserId: state => state.userModule.userId,
        majorDepartId: state => state.basicInfoModule.majorDepartId,
        name: state => state.basicInfoModule.name,
      })
    }

  }
</script>

<style scoped>
  /deep/ .spec-dialog .el-dialog__body {
    /*padding: 3px 30px;*/
    overflow-y: hidden;
    height: calc(100vh - 150px);



  }
  .dialog-title{
    text-align: center;
    font-size: 17px;
  }
  .el-dialog__wrapper.spec-dialog{
    overflow: hidden !important;
    top: auto;
  }

  .card {
    overflow-y: auto /* 开启滚动显示溢出内容 */
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /*关闭横向滚动条*/
  /deep/ .el-scrollbar__bar.is-horizontal{
    height: 0px;
  }

  /*操作的左面板*/
  .panelLeft {
    height: 70vh;
    overflow-y: auto;
    width: 50%;
    float: left;
    padding-right: 10px;
  }

  /*操作的右面板*/
  .panelRight {
    padding-left: 50px;
    padding-right: 10px;
    width: 50%;
    position: relative;
    float: right;
    height: 70vh !important;
    overflow-y: auto;

  }

  /*脚步的据中显示*/
  /deep/ .el-dialog__footer{
    text-align: center;
  }

  /deep/ .el-image__error{
    display: none;
  }



</style>



// WEBPACK FOOTER //
// src/pages/member/memberInfo/PaperInfo.vue